module.exports = __webpack_public_path__ + "img/Tempo-Search.65142680.svg";